(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init() {
    initGallery();
    initQty();
    initForm();
    initUpsell();
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('[data-thumb-for]');
    var slides = document.querySelectorAll('.custom-product__main-slide');
    if (!thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-thumb-for');
        thumbs.forEach(function (x) {
          x.classList.remove('is-active');
        });
        t.classList.add('is-active');
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  function initQty() {
    var input = document.querySelector('[data-qty-input]');
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;
    minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  }

  function initForm() {
    var form = document.querySelector('.custom-product__form, [data-product-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc-btn]');
      var label = form.querySelector('[data-atc-label]');
      var errorEl = form.querySelector('[data-atc-error]');
      if (!btn || btn.disabled) return;
      var originalText = label.textContent.trim();
      btn.disabled = true;
      label.textContent = 'Adding…';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          return r.json().then(function (body) {
            return { ok: r.ok, body: body };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg =
              (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            throw new Error(msg);
          }
          label.textContent = 'Added';
          updateCartCount();
          openUpsell(res.body);
          setTimeout(function () {
            label.textContent = originalText;
            btn.disabled = false;
          }, 1200);
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message || 'Could not add to cart.';
            errorEl.hidden = false;
          }
          label.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  function updateCartCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var anchor = document.querySelector('.custom-header__icon-btn--cart');
        if (!anchor) return;
        var badge = anchor.querySelector('.custom-header__cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'custom-header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            anchor.appendChild(badge);
          }
          badge.textContent = cart.item_count;
          var drawerBadge = document.querySelector('.custom-drawer__cart-count');
          if (drawerBadge) drawerBadge.textContent = cart.item_count;
          anchor.setAttribute(
            'aria-label',
            'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'),
          );
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () {});
  }


  // ─────────────────────────────────────────────────────────────
  //  Баннер после добавления в корзину
  //  Задача одна: не дать человеку остаться наедине с пустой
  //  страницей. Показать, что добавлено, предложить сопутствующее
  //  и дать уйти на оплату в один клик.
  // ─────────────────────────────────────────────────────────────

  var upsellEl = null;
  var lastFocused = null;

  function initUpsell() {
    upsellEl = document.querySelector('[data-upsell]');
    if (!upsellEl) return;

    upsellEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-upsell-close]')) closeUpsell();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && upsellEl && !upsellEl.hidden) closeUpsell();
    });
  }

  function money(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
    return (code === 'AED' ? 'Dhs. ' : code + ' ') + amount;
  }

  function priceLine(item) {
    // item.price — цена за единицу в копейках; final_line_price — за всю строку.
    // Показываем за штуку, количество приписываем отдельно, иначе «Dhs. 2198»
    // на товаре за 1099 читается как ошибка цены.
    var unit = money(item.price);
    var qty = Number(item.quantity || 1);
    return qty > 1 ? unit + ' × ' + qty : unit;
  }

  function openUpsell(item) {
    if (!upsellEl || !item) return;
    lastFocused = document.activeElement;

    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    var title = item.product_title || item.title || '';
    var added = upsellEl.querySelector('[data-upsell-added]');
    if (added) {
      added.innerHTML =
        (img ? '<img class="cart-upsell__added-img" src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="cart-upsell__added-text">' +
        '<p class="cart-upsell__added-title"></p>' +
        '<p class="cart-upsell__added-price">' + priceLine(item) + '</p>' +
        '</div>';
      // текст — через textContent, чтобы название товара не могло принести разметку
      added.querySelector('.cart-upsell__added-title').textContent = title;
    }

    upsellEl.hidden = false;
    document.documentElement.classList.add('has-upsell-open');
    var closeBtn = upsellEl.querySelector('.cart-upsell__close');
    if (closeBtn) closeBtn.focus();

    refreshTotals();
    loadRecommendations();
  }

  function closeUpsell() {
    if (!upsellEl) return;
    upsellEl.hidden = true;
    document.documentElement.classList.remove('has-upsell-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function refreshTotals() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var total = upsellEl.querySelector('[data-upsell-total]');
        var count = upsellEl.querySelector('[data-upsell-count]');
        if (total) total.textContent = money(cart.total_price);
        if (count) {
          count.textContent =
            'In cart: ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
        }
      })
      .catch(function () {});
  }

  function poolProducts() {
    var node = document.querySelector('[data-upsell-pool]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function loadRecommendations() {
    var section = document.querySelector('[data-product-id]');
    var productId = section && section.getAttribute('data-product-id');
    var url =
      ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var items = (data && data.products ? data.products : [])
          .filter(function (p) {
            return p.available;
          })
          .map(function (p) {
            var variant = (p.variants || []).filter(function (v) {
              return v.available;
            })[0];
            return {
              id: variant && variant.id,
              title: p.title,
              url: p.url,
              price: money(p.price),
              image: p.featured_image || (p.images && p.images[0]) || '',
            };
          })
          .filter(function (p) {
            return p.id;
          });
        renderRecommendations(items);
      })
      .catch(function () {
        renderRecommendations([]);
      });
  }

  function renderRecommendations(items) {
    // Чем бы ни ответил Shopify, добираем до трёх из запасного списка —
    // пустой блок «Goes well with» хуже, чем его отсутствие.
    var seen = {};
    var out = [];
    items.concat(poolProducts()).forEach(function (p) {
      if (!p || !p.id || seen[p.id] || out.length >= 3) return;
      seen[p.id] = true;
      out.push(p);
    });

    var wrap = upsellEl.querySelector('[data-upsell-recs]');
    var list = upsellEl.querySelector('[data-upsell-list]');
    if (!wrap || !list) return;
    if (!out.length) {
      wrap.hidden = true;
      return;
    }

    list.innerHTML = '';
    out.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'cart-upsell__item';
      li.innerHTML =
        (p.image ? '<img class="cart-upsell__item-img" src="' + p.image + '" alt="" loading="lazy">' : '') +
        '<div class="cart-upsell__item-text">' +
        '<a class="cart-upsell__item-title" href="' + p.url + '"></a>' +
        '<span class="cart-upsell__item-price"></span>' +
        '</div>' +
        '<button type="button" class="cart-upsell__item-add" data-variant="' + p.id + '">Add</button>';
      li.querySelector('.cart-upsell__item-title').textContent = p.title;
      li.querySelector('.cart-upsell__item-price').textContent = p.price;
      li.querySelector('.cart-upsell__item-add').addEventListener('click', function (e) {
        addRecommendation(e.currentTarget, p.id);
      });
      list.appendChild(li);
    });
    wrap.hidden = false;
  }

  function addRecommendation(btn, variantId) {
    if (btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        updateCartCount();
        refreshTotals();
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
